import './StartSessionModal.css';

/**
 * Full-page gesture gate shown before a lesson or roleplay auto-plays audio.
 * Satisfies browser autoplay policy in live mode (the click IS the gesture)
 * and gives the learner a clean "here's what's about to happen" on-ramp.
 */

export interface StartSessionModalProps {
  eyebrow: string;
  headline: string;
  body: string;
  ctaLabel: string;
  ready: boolean;
  onStart: () => void;
}

export default function StartSessionModal({
  eyebrow,
  headline,
  body,
  ctaLabel,
  ready,
  onStart,
}: StartSessionModalProps) {
  return (
    <div
      className="start-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="start-modal-title"
    >
      <div className="start-modal">
        <p className="start-modal__eyebrow">{eyebrow}</p>
        <h2 id="start-modal-title" className="start-modal__headline">
          {headline}
        </h2>
        <p className="start-modal__body">{body}</p>
        <button type="button" className="start-modal__cta" onClick={onStart} disabled={!ready}>
          <PlayIcon /> {ready ? ctaLabel : 'Loading…'}
        </button>
      </div>
    </div>
  );
}

function PlayIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden>
      <path d="M8 5.5v13l11-6.5z" fill="currentColor" />
    </svg>
  );
}
